import { render, staticRenderFns } from "./VAOrder.vue?vue&type=template&id=4d5c31b8&lang=html"
import script from "./VAOrder.vue?vue&type=script&lang=js"
export * from "./VAOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports